import { useState, useEffect } from "react";
import { URL } from "../Redux/common/url";
function Trustedsection() {
  const [productLists, setProductListt] = useState([]);

  useEffect(() => {
    fetchProductList();
  }, []);

  const fetchProductList = async () => {
    try {
      const response = await fetch(
        `${URL.API_BASE_URL}/publicApi/successListPublic`,
      );
      if (response.ok) {
        const data = await response.json();
        setProductListt(data?.successes); // Store the sliders in state
      }
      const data = await response.json();
      console.log(data);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };
  return (
    <div className="container-fluid py-3 mt-3">
      <div className="row justify-content-center text-center g-2">
        {productLists && productLists.length > 0 ? (
          productLists.map((item, index) => (
            <div className="col-md-4">
              <div className="card-3d h-100">
                <div className="card-content-3d">
                  <h2>{item.title}</h2>
                  <div className="divider" />
                  <p>{item.short_description}</p>
                </div>
                <div className="card-3d-animated"></div>
              </div>
            </div>
          ))
        ) : (
          <p>Loading...</p>
        )}
      </div>
      {/* <div className="col-md-4">
                        <div className="card-3d-animated">
                            <h2>Expert Team</h2>
                            <p>Our skilled professionals ensure top-notch quality in every project.</p>
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="card-3d-animated">
                            <h2>Quality Assurance</h2>
                            <p>We maintain high standards to ensure long-lasting results.</p>
                        </div>
                    </div> */}
    </div>
  );
}

export default Trustedsection;
